<template>
  <div
    v-if="active"
    :class="[
      positionClasses,
      sizeClasses,
      positionType,
      'z-61 inset-ring-1 inset-ring-neutral-400 shadow-around backface-hidden animate-loading-logo flex select-none items-center justify-center rounded-xl bg-white p-1 shadow-black/5',
    ]"
  >
    <img
      v-if="catalogSettings?.logo"
      class="max-h-full max-w-full rounded-lg object-contain"
      :src="catalogSettings.logo"
    />
    <!-- {{ logo }} -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoadingLogo',
  props: {
    active: {
      type: [Boolean, Number],
      default: true,
    },
    size: {
      type: String,
      default: 'lg',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    position: {
      type: String,
      default: 'center',
      validator: (value) =>
        ['center', 'topRight', 'bottomRight', 'topLeft', 'bottomLeft'].includes(
          value
        ),
    },
    positionType: {
      type: String,
      default: 'absolute',
      validator: (value) => ['absolute', 'fixed'].includes(value),
    },
  },
  computed: {
    ...mapGetters(['catalogSettings']),
    sizeClasses() {
      return {
        sm: 'size-20',
        md: 'size-22',
        lg: 'size-24',
      }[this.size];
    },
    positionClasses() {
      const positions = {
        center: 'left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]',
        topRight: 'right-4 top-4',
        bottomRight: 'right-4 bottom-4',
        topLeft: 'left-4 top-4',
        bottomLeft: 'left-4 bottom-4',
      };
      return positions[this.position];
    },
  },
};
</script>

<style scoped></style>
